export enum DrawWaiverActionType {
    OutOfBalanceWaived = 1,
    OutOfBalanceRemoveWaiver = 2,
}
